import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'absolute',
      zIndex: 400,

      width: '100%',
      padding: '1rem',

      textAlign: 'center',

      '& > p': {
        background: theme.palette.background.paper,
        color: theme.palette.secondary.main,
        border: '1px solid #D9D9D9',
        borderRadius: 5,

        maxWidth: '50rem',
        lineHeight: '3.2rem',
        margin: '0 auto',

        fontSize: '1.4rem',
      },
    },
  }),
)
